<template>
  <div class="info">
    <h2>{{ surveyTitle }}</h2>
    <div>ID: {{ surveyID }}</div>
  </div>
  <Button class="addButton" @click="addElement">Element hinzufügen</Button
  ><br />
  <Button class="saveButton" @click="saveMenu">Speichern</Button><br/>
  <button id="reload" @click="reloadPage">Neu laden</button>
  <br/><br/>
  <div class="container">
    <Tree class="tree" :value="treeData" @drop="onDrop">
      <template v-slot="{ node, index, path, tree }">
        <div :data-id="index" @click="onClick(node)">
          <b class="fold" @click="tree.toggleFold(node, path)">
            {{ node.$folded ? '+' : '-' }}
          </b>
          {{ node.text }}
          <button class="removeButton" @click="removeElement(node, path, tree)">
            Löschen
          </button>
        </div>
      </template>
    </Tree>
    <confirm-dialog ref="confirmDialog"></confirm-dialog>
    <div class="details">
      <h2>{{ Details }}</h2>
      ID: {{ surveyID }}_{{ actualNode.ID }}
      <br/><br/>
      <div class="detail-form">
        Titel:
        <input type="text" name="title" id="title" v-model="actualNode.text" />
      </div>
      <button id="editButton" ref="editButton" @click="openSurvey">
        Inhalte bearbeiten
      </button>
    </div>
  </div>
</template>

<script>
import 'he-tree-vue/dist/he-tree-vue.css'
import { Tree, Draggable, Fold } from 'he-tree-vue'
import ApiService from '@/services/ApiService'
import ConfirmDialog from '../components/ConfirmDialog.vue'

export default {
  name: 'EditSurvey',
  components: { Tree: Tree.mixPlugins([Draggable, Fold]), ConfirmDialog },
  data() {
    return {
      treeData: [],
      Details: 'Details',
      nodeTitle: '',
      actualNode: { text: '' },
      surveyID: localStorage.survey_id,
      surveyTitle: localStorage.survey_title,
      menu_id: 0,
      newItemIndex: 1
    }
  },
  methods: {
    addElement: function() {
      this.treeData.push({
        ID: 'ni_' + this.newItemIndex,
        text: 'neues Element',
        title: 'neues Element',
        children: [],
        menu_id: this.menu_id
      })
      this.newItemIndex++
      this.createWPMenu(this.treeData)
    },
    removeElement: async function(node, path, tree) {
      const ok = await this.$refs.confirmDialog.show({
        title: 'Element löschen',
        message: 'Soll dieses Element und alle Unterelemente gelöscht werden?',
        okButton: 'Ja, löschen'
      })
      if (ok) {
        tree.removeNodeByPath(path)
        this.createWPMenu(this.treeData)
        await ApiService.deleteMenuItem(node.menu_id, node.ID, localStorage.user_id, localStorage.usertoken)
      }
    },
    onDrop: function() {
      this.createWPMenu(this.treeData)
    },
    onClick: function(node) {
      //node = JSON.parse(JSON.stringify(node));
      this.actualNode = node
      this.Details = 'Details - ' + node.title
      this.nodeTitle = this.actualNode.title
      this.$refs.editButton.disabled = !Number.isInteger(node.ID)
    },
    openSurvey: function() {
      let url = 'https://www.stuck-komzet.de/wp-admin/admin.php?page=ftcs_admin_create&template=0&mode=update_survey&install=2&sid=' +
          localStorage.survey_id +
          '&pageID=' +
          this.actualNode.ID +
          '&menuTitle=' +
          this.actualNode.text +
          '&fromapp=1&doLogin=1&encr=0&user=' +
          localStorage.username +
          '&pass=' +
          localStorage.password +
          '&hideAllAdmin=1';
      if(localStorage.username == null || localStorage.password == null){
        url = 'https://www.stuck-komzet.de/wp-admin/admin.php?page=ftcs_admin_create&template=0&mode=update_survey&install=2&sid=' +
            localStorage.survey_id +
            '&pageID=' +
            this.actualNode.ID +
            '&menuTitle=' +
            this.actualNode.text +
            '&fromapp=1';
      }
      if(localStorage.fromApp == 1) {
        location.href = url;
      }else{
        window.open(url);
      }
    },
    getMenu: function(sid) {
      if(localStorage.usertoken == "" && localStorage.username != "" && localStorage.password != ""){
        ApiService.getToken(sid, localStorage.username, localStorage.password)
            .then(response => {
              console.log(response);
              console.log(response.data);
                  if (response.data) {
                    if(response.data.token != ""){
                      localStorage.usertoken = response.data.token;
                      console.log("token set: "+localStorage.usertoken);
                    }
                  }
                })
            .catch(error => {
                console.log(error)
              })
        ApiService.getMenuLogin(sid, localStorage.username, localStorage.password)
            .then(response => {
              if (response.data.length > 0) {
                if (response.data[0].menu_id) {
                  this.menu_id = response.data[0].menu_id
                }
                this.createMenu(response.data)
              } else {
                this.addElement()
              }
            })
            .catch(error => {
              console.log(error)
            })
      }else{
        ApiService.getMenu(sid, localStorage.user_id, localStorage.usertoken)
            .then(response => {
              if (response.data.length > 0) {
                if (response.data[0].menu_id) {
                  this.menu_id = response.data[0].menu_id
                }
                this.createMenu(response.data)
              } else {
                this.addElement()
              }
            })
            .catch(error => {
              console.log(error)
            })
      }

    },
    createMenu: function(items) {
      let menu = []
      for (let i = 0; i < items.length; i++) {
        items[i].text = items[i].post_title
        if (items[i].menu_item_parent === '0') {
          items[i].children = []
          menu.push(items[i])
        } else {
          items[i].children = []
          for (let j = 0; j < menu.length; j++) {
            this.findParent(menu[j], items[i])
          }
        }
      }
      this.treeData = menu
    },
    findParent: function(menuItem, needle) {
      if (menuItem.ID === parseInt(needle.menu_item_parent)) {
        menuItem.children.push(needle)
        return true
      }
      if (menuItem.children.length > 0) {
        for (let i = 0; i < menuItem.children.length; i++) {
          let found = this.findParent(menuItem.children[i], needle)
          if (found) {
            return true
          }
        }
      }
    },
    createWPMenu: function(menu) {
      menu = JSON.parse(JSON.stringify(menu))
      let items = []
      let menu_order = 1
      for (let i = 0; i < menu.length; i++) {
        menu[i].menu_item_parent = 0
        menu[i].title = menu[i].text
        menu[i].menu_order = menu_order
        menu_order++
        items.push(menu[i])
        for (let j = 0; j < menu[i].children.length; j++) {
          menu_order = this.traverseChildren(
            menu[i].children[j],
            items,
            menu[i].ID,
            menu_order
          )
        }
      }
      return items
    },
    traverseChildren: function(menuItem, items, id, menu_order) {
      menuItem.menu_item_parent = id
      menuItem.title = menuItem.text
      menuItem.menu_order = menu_order
      menu_order++
      items.push(menuItem)
      for (let i = 0; i < menuItem.children.length; i++) {
        menu_order = this.traverseChildren(
          menuItem.children[i],
          items,
          menuItem.ID,
          menu_order
        )
      }
      menuItem.children = null
      return menu_order
    },
    saveMenu: function() {
      let items = this.createWPMenu(this.treeData)
      ApiService.updateMenu(
        this.menu_id,
        items,
        localStorage.usertoken,
        localStorage.user_id,
        localStorage.survey_id,
        localStorage.username,
        localStorage.password
      )
        .then(response => {
          if (response.data.error === 401) {
            alert('Zugriff verweigert!')
          }
          if (response.data.error === 200) {
            console.log('success ' + response.data.menu_id)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    reloadPage: function (){
      location.href = localStorage.origUrl
    }
  },
  created() {
    this.getMenu(localStorage.survey_id)
  }
}
</script>

<style scoped>
.info {
  margin-bottom: 10px;
}
.addButton {
  margin-bottom: 10px;
}
.saveButton {
  margin-bottom: 20px;
}
.container {
  display: flex;
}
.tree {
  flex-grow: 1;
  cursor: pointer;
}
.fold {
  font-size: 20px;
  margin-right: 10px;
}
.details {
  flex-grow: 1;
  border: 1px solid black;
  margin-left: 10px;
  padding: 10px;
}
#editButton {
  margin-top: 20px;
}
.removeButton {
  margin-left: 10px;
}
</style>
